import { FacebookEditAction } from "../FacebookEditAction";
import { FacebookEditActionTypes } from "../actions/FacebookEditActionTypes";

export const selectAction = (action: FacebookEditAction) =>
  ({
    type: FacebookEditActionTypes.FACEBOOK_SELECT_ACTION,
    action,
  } as const);
